const A = {
  BG_ROBIN_100: "#CAD5FD",
  BG_ROBIN_200: "#B8C7FC",
  BG_ROBIN_300: "#95ACFB",
  BG_ROBIN_400: "#7190F9",
  BG_ROBIN_500: "#4E74F8",
  BG_ROBIN_600: "#3F5ECC",
  BG_SIENNA_100: "#E6D9CD",
  BG_SIENNA_200: "#DECCBC",
  BG_SIENNA_300: "#CEB29B",
  BG_SIENNA_400: "#BD9979",
  BG_SIENNA_500: "#AD7F58",
  BG_SIENNA_600: "#8A6646",
  BG_CHERRY_100: "#FADADB",
  BG_CHERRY_200: "#F7C8CA",
  BG_CHERRY_300: "#F5B6B8",
  BG_CHERRY_400: "#EA6D71",
  BG_CHERRY_500: "#E5484D",
  BG_CHERRY_600: "#B83A3E",
  BG_AQUA_100: "#C1EEFD",
  BG_AQUA_200: "#9AE4FC",
  BG_AQUA_300: "#72D9FB",
  BG_AQUA_400: "#4BCFF9",
  BG_AQUA_500: "#23C4F8",
  BG_AQUA_600: "#07AFE6",
  BG_SAKURA_100: "#FBC8D2",
  BG_SAKURA_200: "#FAB5C3",
  BG_SAKURA_300: "#F791A5",
  BG_SAKURA_400: "#F56C87",
  BG_SAKURA_500: "#F24769",
  BG_SAKURA_600: "#C53955",
  BG_AMBER_100: "#FFF0CC",
  BG_AMBER_200: "#FFEBBB",
  BG_AMBER_300: "#FFE19A",
  BG_AMBER_400: "#FFD778",
  BG_AMBER_500: "#FFCD56",
  BG_AMBER_600: "#D5AA45",
  BG_INK_100: "#2A2E37",
  BG_INK_200: "#23262E",
  BG_INK_300: "#16181D",
  BG_INK_400: "#121317",
  BG_INK_500: "#0B0C0E",
  BG_VANILLA_100: "#FFFFFF",
  BG_VANILLA_200: "#F5F5F5",
  BG_VANILLA_300: "#E9E9E9",
  BG_VANILLA_400: "#C0C1C3",
  BG_SLATE_50: "#62687C",
  BG_SLATE_100: "#3C4152",
  BG_SLATE_200: "#2C3140",
  BG_SLATE_300: "#242834",
  BG_SLATE_400: "#1D212D",
  BG_SLATE_500: "#161922",
  BG_GRADIENT_CORAL: "linear-gradient(114deg, #ED6D68 14.99%, #FCA083 77.27%)",
  "BG_GRADIENT_DARK-SHADOW": "linear-gradient(139deg, rgba(18, 19, 23, 0.80) 0%, rgba(18, 19, 23, 0.90) 98.68%)",
  BG_GRADIENT_DAWN: "linear-gradient(99deg, #7A97FA 4.42%, #F977FF 96.6%)",
  BG_GRADIENT_OCEAN: "linear-gradient(99deg, #48F8CF 4.42%, #28CBF3 96.6%)",
  BG_GRADIENT_SPLASH: "linear-gradient(99deg, #4568DC 4.42%, #324DAA 96.6%)",
  BG_GRADIENT_FLAMINGO: "linear-gradient(92deg, #CA9CD0 1.36%, #D38972 68.48%, #A1B1E7 98.99%)",
  BG_FOREST_200: "#A8F3D3",
  BG_FOREST_300: "#7CEDBE",
  BG_FOREST_400: "#51E7A8",
  BG_FOREST_500: "#25E192",
  BG_FOREST_600: "#1EB475",
  TEXT_ROBIN_100: "#CAD5FD",
  TEXT_ROBIN_200: "#B8C7FC",
  TEXT_ROBIN_300: "#95ACFB",
  TEXT_ROBIN_400: "#7190F9",
  TEXT_ROBIN_500: "#4E74F8",
  TEXT_ROBIN_600: "#3F5ECC",
  TEXT_SIENNA_100: "#E6D9CD",
  TEXT_SIENNA_200: "#DECCBC",
  TEXT_SIENNA_300: "#CEB29B",
  TEXT_SIENNA_400: "#BD9979",
  TEXT_SIENNA_500: "#AD7F58",
  TEXT_SIENNA_600: "#8A6646",
  TEXT_CHERRY_100: "#FADADB",
  TEXT_CHERRY_200: "#F7C8CA",
  TEXT_CHERRY_300: "#F5B6B8",
  TEXT_CHERRY_400: "#EA6D71",
  TEXT_CHERRY_500: "#E5484D",
  TEXT_CHERRY_600: "#B83A3E",
  TEXT_AQUA_100: "#C1EEFD",
  TEXT_AQUA_200: "#9AE4FC",
  TEXT_AQUA_300: "#72D9FB",
  TEXT_AQUA_400: "#4BCFF9",
  TEXT_AQUA_500: "#23C4F8",
  TEXT_AQUA_600: "#07AFE6",
  TEXT_SAKURA_100: "#FBC8D2",
  TEXT_SAKURA_200: "#FAB5C3",
  TEXT_SAKURA_300: "#F791A5",
  TEXT_SAKURA_400: "#F56C87",
  TEXT_SAKURA_500: "#F24769",
  TEXT_SAKURA_600: "#C53955",
  TEXT_AMBER_100: "#FFF0CC",
  TEXT_AMBER_200: "#FFEBBB",
  TEXT_AMBER_300: "#FFE19A",
  TEXT_AMBER_400: "#FFD778",
  TEXT_AMBER_500: "#FFCD56",
  TEXT_AMBER_600: "#D5AA45",
  TEXT_INK_100: "#2A2E37",
  TEXT_INK_200: "#23262E",
  TEXT_INK_300: "#16181D",
  TEXT_INK_400: "#121317",
  TEXT_INK_500: "#0B0C0E",
  TEXT_VANILLA_100: "#FFFFFF",
  TEXT_VANILLA_200: "#F5F5F5",
  TEXT_VANILLA_300: "#E9E9E9",
  TEXT_VANILLA_400: "#C0C1C3",
  TEXT_SLATE_200: "#2C3140",
  TEXT_SLATE_300: "#242834",
  TEXT_SLATE_400: "#1D212D",
  TEXT_SLATE_500: "#161922",
  TEXT_GRADIENT_CORAL: "linear-gradient(114deg, #ED6D68 14.99%, #FCA083 77.27%)",
  "TEXT_GRADIENT_DARK-SHADOW": "linear-gradient(139deg, rgba(18, 19, 23, 0.80) 0%, rgba(18, 19, 23, 0.90) 98.68%)",
  TEXT_GRADIENT_DAWN: "linear-gradient(99deg, #7A97FA 4.42%, #F977FF 96.6%)",
  TEXT_GRADIENT_OCEAN: "linear-gradient(99deg, #48F8CF 4.42%, #28CBF3 96.6%)",
  TEXT_GRADIENT_SPLASH: "linear-gradient(99deg, #4568DC 4.42%, #324DAA 96.6%)",
  TEXT_GRADIENT_FLAMINGO: "linear-gradient(92deg, #CA9CD0 1.36%, #D38972 68.48%, #A1B1E7 98.99%)",
  TEXT_FOREST_200: "#A8F3D3",
  TEXT_FOREST_300: "#7CEDBE",
  TEXT_FOREST_400: "#51E7A8",
  TEXT_FOREST_500: "#25E192",
  TEXT_FOREST_600: "#1EB475"
}, F = {
  "robin-100": "#CAD5FD",
  "robin-200": "#B8C7FC",
  "robin-300": "#95ACFB",
  "robin-400": "#7190F9",
  "robin-500": "#4E74F8",
  "robin-600": "#3F5ECC",
  "sienna-100": "#E6D9CD",
  "sienna-200": "#DECCBC",
  "sienna-300": "#CEB29B",
  "sienna-400": "#BD9979",
  "sienna-500": "#AD7F58",
  "sienna-600": "#8A6646",
  "cherry-100": "#FADADB",
  "cherry-200": "#F7C8CA",
  "cherry-300": "#F5B6B8",
  "cherry-400": "#EA6D71",
  "cherry-500": "#E5484D",
  "cherry-600": "#B83A3E",
  "aqua-100": "#C1EEFD",
  "aqua-200": "#9AE4FC",
  "aqua-300": "#72D9FB",
  "aqua-400": "#4BCFF9",
  "aqua-500": "#23C4F8",
  "aqua-600": "#07AFE6",
  "sakura-100": "#FBC8D2",
  "sakura-200": "#FAB5C3",
  "sakura-300": "#F791A5",
  "sakura-400": "#F56C87",
  "sakura-500": "#F24769",
  "sakura-600": "#C53955",
  "amber-100": "#FFF0CC",
  "amber-200": "#FFEBBB",
  "amber-300": "#FFE19A",
  "amber-400": "#FFD778",
  "amber-500": "#FFCD56",
  "amber-600": "#D5AA45",
  "ink-100": "#2A2E37",
  "ink-200": "#23262E",
  "ink-300": "#16181D",
  "ink-400": "#121317",
  "ink-500": "#0B0C0E",
  "vanilla-100": "#FFFFFF",
  "vanilla-200": "#F5F5F5",
  "vanilla-300": "#E9E9E9",
  "vanilla-400": "#C0C1C3",
  "slate-50": "#62687C",
  "slate-100": "#3C4152",
  "slate-200": "#2C3140",
  "slate-300": "#242834",
  "slate-400": "#1D212D",
  "slate-500": "#161922",
  "gradient-coral": "linear-gradient(114deg, #ED6D68 14.99%, #FCA083 77.27%)",
  "gradient-dark-shadow": "linear-gradient(139deg, rgba(18, 19, 23, 0.80) 0%, rgba(18, 19, 23, 0.90) 98.68%)",
  "gradient-dawn": "linear-gradient(99deg, #7A97FA 4.42%, #F977FF 96.6%)",
  "gradient-ocean": "linear-gradient(99deg, #48F8CF 4.42%, #28CBF3 96.6%)",
  "gradient-splash": "linear-gradient(99deg, #4568DC 4.42%, #324DAA 96.6%)",
  "gradient-flamingo": "linear-gradient(92deg, #CA9CD0 1.36%, #D38972 68.48%, #A1B1E7 98.99%)",
  "forest-200": "#A8F3D3",
  "forest-300": "#7CEDBE",
  "forest-400": "#51E7A8",
  "forest-500": "#25E192",
  "forest-600": "#1EB475"
}, E = {
  PADDING_1: "0.25rem",
  PADDING_2: "0.5rem",
  PADDING_3: "0.75rem",
  PADDING_4: "1rem",
  PADDING_5: "1.25rem",
  PADDING_6: "1.5rem",
  PADDING_7: "1.75rem",
  PADDING_8: "2rem",
  PADDING_10: "2.5rem",
  PADDING_12: "3rem",
  PADDING_16: "4rem",
  PADDING_20: "5rem",
  PADDING_24: "6rem",
  PADDING_32: "8rem",
  PADDING_40: "10rem",
  PADDING_48: "12rem",
  PADDING_56: "14rem",
  PADDING_64: "16rem",
  MARGIN_1: "0.25rem",
  MARGIN_2: "0.5rem",
  MARGIN_3: "0.75rem",
  MARGIN_4: "1rem",
  MARGIN_5: "1.25rem",
  MARGIN_6: "1.5rem",
  MARGIN_7: "1.75rem",
  MARGIN_8: "2rem",
  MARGIN_10: "2.5rem",
  MARGIN_12: "3rem",
  MARGIN_16: "4rem",
  MARGIN_20: "5rem",
  MARGIN_24: "6rem",
  MARGIN_32: "8rem",
  MARGIN_40: "10rem",
  MARGIN_48: "12rem",
  MARGIN_56: "14rem",
  MARGIN_64: "16rem"
}, t = {
  FONTSIZE_XS: "0.75rem",
  FONTSIZE_SM: "0.875rem",
  FONTSIZE_LG: "1.125rem",
  FONTSIZE_XL: "1.25rem",
  FONTSIZE_2XL: "1.5rem",
  FONTSIZE_3XL: "1.875rem",
  FONTSIZE_4XL: "2.25rem",
  FONTSIZE_5XL: "3rem",
  FONTSIZE_6XL: "3.75rem",
  FONTSIZE_7XL: "4.5rem",
  FONTSIZE_8XL: "6rem",
  FONTSIZE_9XL: "8rem",
  FONTWEIGHT_THIN: "100",
  FONTWEIGHT_EXTRALIGHT: "200",
  FONTWEIGHT_LIGHT: "300",
  FONTWEIGHT_NORMAL: "400",
  FONTWEIGHT_MEDIUM: "500",
  FONTWEIGHT_SEMIBOLD: "600",
  FONTWEIGHT_BOLD: "700",
  FONTWEIGHT_EXTRABOLD: "800",
  FONTWEIGHT_BLACK: "900"
}, e = {
  Robin: {
    100: {
      value: "#CAD5FD",
      type: "color"
    },
    200: {
      value: "#B8C7FC",
      type: "color"
    },
    300: {
      value: "#95ACFB",
      type: "color"
    },
    400: {
      value: "#7190F9",
      type: "color"
    },
    500: {
      value: "#4E74F8",
      type: "color"
    },
    600: {
      value: "#3F5ECC",
      type: "color"
    }
  },
  Sienna: {
    100: {
      value: "#E6D9CD",
      type: "color"
    },
    200: {
      value: "#DECCBC",
      type: "color"
    },
    300: {
      value: "#CEB29B",
      type: "color"
    },
    400: {
      value: "#BD9979",
      type: "color"
    },
    500: {
      value: "#AD7F58",
      type: "color"
    },
    600: {
      value: "#8A6646",
      type: "color"
    }
  },
  Cherry: {
    100: {
      value: "#FADADB",
      type: "color"
    },
    200: {
      value: "#F7C8CA",
      type: "color"
    },
    300: {
      value: "#F5B6B8",
      type: "color"
    },
    400: {
      value: "#EA6D71",
      type: "color"
    },
    500: {
      value: "#E5484D",
      type: "color"
    },
    600: {
      value: "#B83A3E",
      type: "color"
    }
  },
  Aqua: {
    100: {
      value: "#C1EEFD",
      type: "color"
    },
    200: {
      value: "#9AE4FC",
      type: "color"
    },
    300: {
      value: "#72D9FB",
      type: "color"
    },
    400: {
      value: "#4BCFF9",
      type: "color"
    },
    500: {
      value: "#23C4F8",
      type: "color"
    },
    600: {
      value: "#07AFE6",
      type: "color"
    }
  },
  Sakura: {
    100: {
      value: "#FBC8D2",
      type: "color"
    },
    200: {
      value: "#FAB5C3",
      type: "color"
    },
    300: {
      value: "#F791A5",
      type: "color"
    },
    400: {
      value: "#F56C87",
      type: "color"
    },
    500: {
      value: "#F24769",
      type: "color"
    },
    600: {
      value: "#C53955",
      type: "color"
    }
  },
  Amber: {
    100: {
      value: "#FFF0CC",
      type: "color"
    },
    200: {
      value: "#FFEBBB",
      type: "color"
    },
    300: {
      value: "#FFE19A",
      type: "color"
    },
    400: {
      value: "#FFD778",
      type: "color"
    },
    500: {
      value: "#FFCD56",
      type: "color"
    },
    600: {
      value: "#D5AA45",
      type: "color"
    }
  },
  Ink: {
    100: {
      value: "#2A2E37",
      type: "color"
    },
    200: {
      value: "#23262E",
      type: "color"
    },
    300: {
      value: "#16181D",
      type: "color"
    },
    400: {
      value: "#121317",
      type: "color"
    },
    500: {
      value: "#0B0C0E",
      type: "color"
    }
  },
  Vanilla: {
    100: {
      value: "#FFFFFF",
      type: "color"
    },
    200: {
      value: "#F5F5F5",
      type: "color"
    },
    300: {
      value: "#E9E9E9",
      type: "color"
    },
    400: {
      value: "#C0C1C3",
      type: "color"
    }
  },
  Slate: {
    50: {
      value: "#62687C",
      type: "color"
    },
    100: {
      value: "#3C4152",
      type: "color"
    },
    200: {
      value: "#2C3140",
      type: "color"
    },
    300: {
      value: "#242834",
      type: "color"
    },
    400: {
      value: "#1D212D",
      type: "color"
    },
    500: {
      value: "#161922",
      type: "color"
    }
  },
  Gradient: {
    Coral: {
      value: "linear-gradient(114deg, #ED6D68 14.99%, #FCA083 77.27%)",
      type: "color"
    },
    "Dark-Shadow": {
      value: "linear-gradient(139deg, rgba(18, 19, 23, 0.80) 0%, rgba(18, 19, 23, 0.90) 98.68%)",
      type: "color"
    },
    Dawn: {
      value: "linear-gradient(99deg, #7A97FA 4.42%, #F977FF 96.6%)",
      type: "color"
    },
    Ocean: {
      value: "linear-gradient(99deg, #48F8CF 4.42%, #28CBF3 96.6%)",
      type: "color"
    },
    Splash: {
      value: "linear-gradient(99deg, #4568DC 4.42%, #324DAA 96.6%)",
      type: "color"
    },
    Flamingo: {
      value: "linear-gradient(92deg, #CA9CD0 1.36%, #D38972 68.48%, #A1B1E7 98.99%)",
      type: "color"
    }
  },
  Forest: {
    200: {
      value: "#A8F3D3",
      type: "color"
    },
    300: {
      value: "#7CEDBE",
      type: "color"
    },
    400: {
      value: "#51E7A8",
      type: "color"
    },
    500: {
      value: "#25E192",
      type: "color"
    },
    600: {
      value: "#1EB475",
      type: "color"
    }
  }
}, a = {
  Robin: {
    100: {
      value: "#CAD5FD",
      type: "color"
    },
    200: {
      value: "#B8C7FC",
      type: "color"
    },
    300: {
      value: "#95ACFB",
      type: "color"
    },
    400: {
      value: "#7190F9",
      type: "color"
    },
    500: {
      value: "#4E74F8",
      type: "color"
    },
    600: {
      value: "#3F5ECC",
      type: "color"
    }
  },
  Sienna: {
    100: {
      value: "#E6D9CD",
      type: "color"
    },
    200: {
      value: "#DECCBC",
      type: "color"
    },
    300: {
      value: "#CEB29B",
      type: "color"
    },
    400: {
      value: "#BD9979",
      type: "color"
    },
    500: {
      value: "#AD7F58",
      type: "color"
    },
    600: {
      value: "#8A6646",
      type: "color"
    }
  },
  Cherry: {
    100: {
      value: "#FADADB",
      type: "color"
    },
    200: {
      value: "#F7C8CA",
      type: "color"
    },
    300: {
      value: "#F5B6B8",
      type: "color"
    },
    400: {
      value: "#EA6D71",
      type: "color"
    },
    500: {
      value: "#E5484D",
      type: "color"
    },
    600: {
      value: "#B83A3E",
      type: "color"
    }
  },
  Aqua: {
    100: {
      value: "#C1EEFD",
      type: "color"
    },
    200: {
      value: "#9AE4FC",
      type: "color"
    },
    300: {
      value: "#72D9FB",
      type: "color"
    },
    400: {
      value: "#4BCFF9",
      type: "color"
    },
    500: {
      value: "#23C4F8",
      type: "color"
    },
    600: {
      value: "#07AFE6",
      type: "color"
    }
  },
  Sakura: {
    100: {
      value: "#FBC8D2",
      type: "color"
    },
    200: {
      value: "#FAB5C3",
      type: "color"
    },
    300: {
      value: "#F791A5",
      type: "color"
    },
    400: {
      value: "#F56C87",
      type: "color"
    },
    500: {
      value: "#F24769",
      type: "color"
    },
    600: {
      value: "#C53955",
      type: "color"
    }
  },
  Amber: {
    100: {
      value: "#FFF0CC",
      type: "color"
    },
    200: {
      value: "#FFEBBB",
      type: "color"
    },
    300: {
      value: "#FFE19A",
      type: "color"
    },
    400: {
      value: "#FFD778",
      type: "color"
    },
    500: {
      value: "#FFCD56",
      type: "color"
    },
    600: {
      value: "#D5AA45",
      type: "color"
    }
  },
  Ink: {
    100: {
      value: "#2A2E37",
      type: "color"
    },
    200: {
      value: "#23262E",
      type: "color"
    },
    300: {
      value: "#16181D",
      type: "color"
    },
    400: {
      value: "#121317",
      type: "color"
    },
    500: {
      value: "#0B0C0E",
      type: "color"
    }
  },
  Vanilla: {
    100: {
      value: "#FFFFFF",
      type: "color"
    },
    200: {
      value: "#F5F5F5",
      type: "color"
    },
    300: {
      value: "#E9E9E9",
      type: "color"
    },
    400: {
      value: "#C0C1C3",
      type: "color"
    }
  },
  Slate: {
    200: {
      value: "#2C3140",
      type: "color"
    },
    300: {
      value: "#242834",
      type: "color"
    },
    400: {
      value: "#1D212D",
      type: "color"
    },
    500: {
      value: "#161922",
      type: "color"
    }
  },
  Gradient: {
    Coral: {
      value: "linear-gradient(114deg, #ED6D68 14.99%, #FCA083 77.27%)",
      type: "color"
    },
    "Dark-Shadow": {
      value: "linear-gradient(139deg, rgba(18, 19, 23, 0.80) 0%, rgba(18, 19, 23, 0.90) 98.68%)",
      type: "color"
    },
    Dawn: {
      value: "linear-gradient(99deg, #7A97FA 4.42%, #F977FF 96.6%)",
      type: "color"
    },
    Ocean: {
      value: "linear-gradient(99deg, #48F8CF 4.42%, #28CBF3 96.6%)",
      type: "color"
    },
    Splash: {
      value: "linear-gradient(99deg, #4568DC 4.42%, #324DAA 96.6%)",
      type: "color"
    },
    Flamingo: {
      value: "linear-gradient(92deg, #CA9CD0 1.36%, #D38972 68.48%, #A1B1E7 98.99%)",
      type: "color"
    }
  },
  Forest: {
    200: {
      value: "#A8F3D3",
      type: "color"
    },
    300: {
      value: "#7CEDBE",
      type: "color"
    },
    400: {
      value: "#51E7A8",
      type: "color"
    },
    500: {
      value: "#25E192",
      type: "color"
    },
    600: {
      value: "#1EB475",
      type: "color"
    }
  }
}, p = {
  bg: e,
  text: a
}, l = {
  1: {
    value: "0.25rem",
    type: "spacing"
  },
  2: {
    value: "0.5rem",
    type: "spacing"
  },
  3: {
    value: "0.75rem",
    type: "spacing"
  },
  4: {
    value: "1rem",
    type: "spacing"
  },
  5: {
    value: "1.25rem",
    type: "spacing"
  },
  6: {
    value: "1.5rem",
    type: "spacing"
  },
  7: {
    value: "1.75rem",
    type: "spacing"
  },
  8: {
    value: "2rem",
    type: "spacing"
  },
  10: {
    value: "2.5rem",
    type: "spacing"
  },
  12: {
    value: "3rem",
    type: "spacing"
  },
  16: {
    value: "4rem",
    type: "spacing"
  },
  20: {
    value: "5rem",
    type: "spacing"
  },
  24: {
    value: "6rem",
    type: "spacing"
  },
  32: {
    value: "8rem",
    type: "spacing"
  },
  40: {
    value: "10rem",
    type: "spacing"
  },
  48: {
    value: "12rem",
    type: "spacing"
  },
  56: {
    value: "14rem",
    type: "spacing"
  },
  64: {
    value: "16rem",
    type: "spacing"
  }
}, r = {
  1: {
    value: "0.25rem",
    type: "spacing"
  },
  2: {
    value: "0.5rem",
    type: "spacing"
  },
  3: {
    value: "0.75rem",
    type: "spacing"
  },
  4: {
    value: "1rem",
    type: "spacing"
  },
  5: {
    value: "1.25rem",
    type: "spacing"
  },
  6: {
    value: "1.5rem",
    type: "spacing"
  },
  7: {
    value: "1.75rem",
    type: "spacing"
  },
  8: {
    value: "2rem",
    type: "spacing"
  },
  10: {
    value: "2.5rem",
    type: "spacing"
  },
  12: {
    value: "3rem",
    type: "spacing"
  },
  16: {
    value: "4rem",
    type: "spacing"
  },
  20: {
    value: "5rem",
    type: "spacing"
  },
  24: {
    value: "6rem",
    type: "spacing"
  },
  32: {
    value: "8rem",
    type: "spacing"
  },
  40: {
    value: "10rem",
    type: "spacing"
  },
  48: {
    value: "12rem",
    type: "spacing"
  },
  56: {
    value: "14rem",
    type: "spacing"
  },
  64: {
    value: "16rem",
    type: "spacing"
  }
}, y = {
  padding: l,
  margin: r
}, o = {
  xs: {
    value: "0.75rem",
    type: "typography"
  },
  sm: {
    value: "0.875rem",
    type: "typography"
  },
  lg: {
    value: "1.125rem",
    type: "typography"
  },
  xl: {
    value: "1.25rem",
    type: "typography"
  },
  "2xl": {
    value: "1.5rem",
    type: "typography"
  },
  "3xl": {
    value: "1.875rem",
    type: "typography"
  },
  "4xl": {
    value: "2.25rem",
    type: "typography"
  },
  "5xl": {
    value: "3rem",
    type: "typography"
  },
  "6xl": {
    value: "3.75rem",
    type: "typography"
  },
  "7xl": {
    value: "4.5rem",
    type: "typography"
  },
  "8xl": {
    value: "6rem",
    type: "typography"
  },
  "9xl": {
    value: "8rem",
    type: "typography"
  }
}, _ = {
  thin: {
    value: "100",
    type: "typography"
  },
  extralight: {
    value: "200",
    type: "typography"
  },
  light: {
    value: "300",
    type: "typography"
  },
  normal: {
    value: "400",
    type: "typography"
  },
  medium: {
    value: "500",
    type: "typography"
  },
  semibold: {
    value: "600",
    type: "typography"
  },
  bold: {
    value: "700",
    type: "typography"
  },
  extrabold: {
    value: "800",
    type: "typography"
  },
  black: {
    value: "900",
    type: "typography"
  }
}, C = {
  fontSize: o,
  fontWeight: _
};
export {
  A as Color,
  F as ColorTailwind,
  E as Spacing,
  t as Typography,
  p as colorTokens,
  y as spacingTokens,
  C as typographyTokens
};
